import React from "react";
import { Resource } from "react-admin";

export default () => <Resource name="providers" />;
